import { FilterDate } from '../baseInputTypes/FilterDate'

type Props = {}
export const SecuredFromDate = (props: Props) => (
  <FilterDate
    label="Secured From"
    fieldName="securedFrom"
    fieldPath="mediaDetails.securedFrom"
  />
)

export const SecuredToDate = (props: Props) => (
  <FilterDate
    label="Secured To"
    fieldName="securedTo"
    fieldPath="mediaDetails.securedTo"
  />
)
